import { Typography } from 'antd';
import { ContainerOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';

type Props = {
    open: boolean;
    onConfirm: () => void;
    onClose: () => void;
    isArchiving?: boolean;
};

const ArchiveManifestModal = ({ open, isArchiving, onConfirm, onClose }: Props) => {
    return (
        <ConfirmationModal
            width={400}
            open={open}
            icon={<ContainerOutlined />}
            title="Archive Manifest?"
            confirmButtonText="Archive"
            confirmationButtonLoading={isArchiving}
            onCancel={onClose}
            onConfirm={onConfirm}
            content={<Typography.Text>The manifest will be added to the archive.</Typography.Text>}
        />
    );
};

export default ArchiveManifestModal;
